<style>
  .bm-view {
    height: 300px;
    width: 350px;
  }

</style>
<template>
  <div class="detailMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1>{{ detailData.name }}</h1>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">编辑</el-dropdown-item>
            <el-dropdown-item command="del">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="cardBottom">
        <el-tabs tab-position="left" style="height: 520px;">
          <el-tab-pane label="详情">
            <h1>产品详情</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>产品名称</label> <br />
                  <span>{{ detailData.name }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>通信类型</label> <br />
                  <span v-if="detailData.commuType==1">TCP</span>
                  <span v-else-if="detailData.commuType==2">UDP</span>
                  <span v-else-if="detailData.commuType==3">MQTT</span>
                  <span v-else-if="detailData.commuType==4">HTTP</span>
                  <span v-else-if="detailData.commuType==5">COAP</span>
                  <span v-else>---</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>厂家平台</label> <br />
                  <span>{{getAccessPlatformLabel(detailData.accessPlatform)}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>网关协议</label> <br />
                  <span>{{
                    detailData.moduleProtocolName != null ? detailData.moduleProtocolName : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>设备协议</label> <br />
                  <span>{{
                    detailData.deviceProtocolName != null
                      ? detailData.deviceProtocolName
                      : "---"
                  }}</span>
                </div>
              </el-col>

              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>备注</label> <br />
                  <span>{{detailData.remark}}</span>
                </div>
              </el-col>
            </el-row>
            <h1 style="margin-top:30px">系统信息</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建人</label> <br />
                  <span>{{
                    detailData.creator != null ? detailData.creator : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建时间</label> <br />
                  <span>{{
                    detailData.createDate != null
                      ? changeDate(detailData.createDate)
                      : "---"
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";

  export default {
    data() {
      return {
        id: this.$route.query.id,
        routeList: this.$route.meta.routeList,
        detailData: {}, //详情数据
        accessPlatformList: []
      };
    },
    created() {},
    methods: {

      getAccessPlatformLabel(accessPlatform) {
        let obj = this.accessPlatformList.filter(x => x.value == accessPlatform)
        if (obj[0]) {
          return obj[0].content
        }
        return '--'
      },

      getAccessPlatformList() {
        API.getDictionaryListByCode({
          typeCode: "access_platform"
        }).then(res => {
          if (res.code === 1) {
            this.accessPlatformList = res.data.dictionaryList
          }
        })

      },
      //单独删除
      handleCommand(val) {
        if (val == 'del') {
          this.delBtn(this.id)
        }
        if (val == 'edit') {
          this.$router.push({
            path: "/product/productAdd",
            query: {
              id: this.id,
              flag: 'edit'
            }
          });
        }
      },

      //删除功能 单独批量公用
      delBtn(delID) {
        let para = {
          ids: delID
        }
        this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          API.delPlatformDevDevice(para).then(res => {
            if (res.code == 1) {
              this.$message.success('删除成功');
              this.getpageList();
            } else {
              this.$message.error('删除失败');
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      //格式化时间
      changeDate(time) {
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },
      //获取设备详情
      getProductView() {
        let id = this.$route.query.id;
        API.platformProductView(id).then(res => {
          if (res.code == 1) {
            this.detailData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      },
    },
    mounted() {
      this.getAccessPlatformList()
      this.getProductView();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/productDetail.vue